export default (urgency: number): string => {
  switch (urgency) {
    case 0:
      return 'Faible';
    case 1:
      return 'Moyen';
    case 2:
      return 'Élevé';
    default:
      return '';
  }
};
